<template>
    <div class="games">
        <div class="game-title show-page">
            <div class="t1 bold bounceUpIn">Games</div>
            <div class="arrow-box slideInLeft">
                <img @click="scrollSlide(-1, 1)" src="@/assets/index/games/arrow.png" alt="">
                <img @click="scrollSlide(1, 1)" class="right" src="@/assets/index/games/arrow.png" alt="">
            </div>
        </div>
        <div class="game-box show-page">
            <img class="mile-line zoomIn" src="@/assets/index/milestone/milestone2.png" alt="">
            <div ref="scroll1" class="home-gamebox-scroll">
                <div v-for="(item,idx) in files" :key="idx" @click="goToGame(item.name)" class="home-gamebox zoomIn" :style="`animation-delay:${getDt(idx)}s`">
                    <div class="gamebox-area">
                        <div class="bg-pic" style="display:inline-block;">
                        <img style="width:100%" :src="item.imgUrl" />
                        </div>
                        <img
                        class="title-pic"
                        :src="item.logo"
                        alt=""
                        />
                    </div>

                    <div class="home-gamebox-textbox">
                        <div class="title-box h2 bold">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {OLDPAGE} from '@/utils/constant'

export default {
    data(){
        return {
            games:0,
            gamesdt:0.1,
            files:[
                {name : "NFT Farmer", imgUrl:require("@/assets/index/games/game1.jpg"), logo:require("@/assets/index/games/momohead.png")},
                {name : "Blockchain Brawler", imgUrl:require("@/assets/index/games/game5.jpg"), logo:require("@/assets/index/games/blackhead.png")},
                {name : "Token Master", imgUrl:require("@/assets/index/games/game4.jpg"), logo:require("@/assets/index/games/tokenhead.png")},
                {name : "Trade Action", imgUrl:require("@/assets/index/games/game3.jpg"), logo:require("@/assets/index/games/contesthead.png")},
                {name : "MOMO:Tactical Party Slaye", imgUrl:require("@/assets/index/games/game6.jpg"), logo:require("@/assets/index/games/partyhead.png")},
            ]
        }
    },

    mounted() {
        
    },

    methods:{
        goToGame(name){
            switch(name) {
                case "NFT Farmer":
                    window.open(`${OLDPAGE}#/iframe/momo`)
                    break;
                case "Blockchain Brawler":
                    window.open(`${OLDPAGE}#/block-brawler`)
                    break;
                case "Token Master":
                    window.open(`${OLDPAGE}#/iframe/tokenmaster`)
                    break;
                case "Trade Action":
                    window.open(`${OLDPAGE}#/iframe/contest`)
                    break;
                default:
                    break;
            }
        },
        getDt(idx){
            return this.games + this.gamesdt*idx
        },
        scrollSlide(direction) {
            const $scroll =  window.$(this.$refs.scroll1);
            const wholeWidth = $scroll.scrollWidth;
            const scrollOffset = $scroll.scrollLeft();

            const scrollTo =
                direction < 0
                ? scrollOffset - 200 < 0
                    ? 0
                    : scrollOffset - 200
                : scrollOffset + 200 > wholeWidth
                ? wholeWidth
                : scrollOffset + 200;

            $scroll.animate(
                {
                scrollLeft: `${scrollTo}px`,
                },
                200
            );
        },
    }
}
</script>

<style lang="less" scoped>
    .games{
        padding: 157px 0;

        .game-title{
            text-align : center;
            position: relative;
            margin-bottom: 30px;

            .arrow-box{
                position: absolute;
                right: 10%;
                top: 50%;
                transform: translate(0, -50%);

                img{
                    width: 44px;
                    cursor: pointer;
                    margin: 0 5px;
                }

                .right{
                    transform: rotate(180deg);
                }
            }
        }

        .game-box{
            width: 85%;
            margin: auto;

            .mile-line{
                width: 100%;
                margin-bottom: 10px;
            }
        }

        .home-gamebox-scroll {
            white-space: nowrap;
            overflow: auto;
            max-width: 100%;
            position: relative;

            padding: 0 0 5px 0;
        }

        .home-gamebox {
            /* max-width: 350px;
            display: inline-block; */
            cursor: pointer;
            max-width: 335px;
            display: inline-block;
            margin: 0 2% 0 0;
            transition: 0.2s all;
            position: relative;
            background: #000000;
            // background: #282B2F;

            .gamebox-area {
                position: relative;
            }

            .bg-pic {
                overflow: hidden;
                display: inline-block;

                img {
                transition: 0.2s all;
                }
            }

            .title-pic {
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 150px;
                transform: translate(-50%, -50%);
            }

            .home-gamebox-textbox{
                position: relative;
                color: white;
                height: 80px;

                .title-box{
                    position: absolute;
                    left: 21px;
                    top: 50%;
                    transform: translate(0, -50%);

                    white-space: break-spaces;
                    max-width: 100%;
                    line-height: 30px;
                }
            }
        }

        .home-gamebox:hover {
            .gamebox-area {
                .bg-pic {
                img {
                    transform: scale(1.1);
                }
                }
            }
        }
    }
</style>
